var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownGen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_567_32737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 3.33333,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.583333,
    y: 0.583333,
    width: 20.8333,
    height: 20.8333,
    rx: 3.75,
    stroke: "#070519",
    strokeWidth: 0.833333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7789 16.5556H8.22331C7.99553 16.5556 7.80664 16.3667 7.80664 16.139C7.80664 15.9112 7.99553 15.7223 8.22331 15.7223H13.7789C14.0066 15.7223 14.1955 15.9112 14.1955 16.139C14.1955 16.3667 14.0066 16.5556 13.7789 16.5556Z",
    fill: "#3C45CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.639 7.40009L13.4168 8.98898C13.1223 9.20009 12.7001 9.07231 12.5723 8.73342L11.5223 5.93342C11.3446 5.45009 10.6612 5.45009 10.4835 5.93342L9.4279 8.72787C9.30012 9.07231 8.88345 9.20009 8.58901 8.98342L6.36679 7.39453C5.92234 7.08342 5.33346 7.52231 5.51679 8.03898L7.8279 14.5112C7.90568 14.7334 8.11679 14.8779 8.35012 14.8779H13.6446C13.8779 14.8779 14.089 14.7279 14.1668 14.5112L16.4779 8.03898C16.6668 7.52231 16.0779 7.08342 15.639 7.40009ZM12.389 12.5279H9.61123C9.38346 12.5279 9.19457 12.339 9.19457 12.1112C9.19457 11.8834 9.38346 11.6945 9.61123 11.6945H12.389C12.6168 11.6945 12.8057 11.8834 12.8057 12.1112C12.8057 12.339 12.6168 12.5279 12.389 12.5279Z",
    fill: "#3C45CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_567_32737",
    x: 0.166016,
    y: 0.166626,
    width: 21.668,
    height: 23.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.0196078 0 0 0 0 0.0980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_567_32737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_567_32737",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownGen);
export default __webpack_public_path__ + "static/media/CrownGen.43526210e59ff9721893b5e1f7884981.svg";
export { ForwardRef as ReactComponent };